import FloorPlanComponent from "../FloorPlanComponent.vue";

export default [
  {
    path: "/floor-plan",
    name: "FloorPlan",
    meta: { layout: "default", requiresAuthOrAccountRequest: true },
    component: FloorPlanComponent,
  },
];
